// Action creators
import actionTypes from '../constants/actionTypes/get-template-data-action-types';
import { Observable } from 'rxjs';
import gjeFetch from 'gje-fetch';
import { setGlobalError } from '../actions/error-actions';
import endpoint from '../config/endpoint';
import { DEFAULT_ERROR_MSG } from '../constants/errors';

const fetchTemplateDataRequest = (param: any) =>
    gjeFetch
        .postJSON(`/${endpoint}/api/template/getTemplateData`, param, {
            accept: 'application/json'
        })
        .then(response => response.json());

export const fetchTemplateData = (
    productNumber: number,
    agreementProduct: number
) => ({
    type: actionTypes.REQUEST,
    payload: {
        productNumber,
        agreementProduct
    }
});

const fetchTemplateDataSuccess = payload => ({
    type: actionTypes.RECEIVE,
    payload
});

const fetchTemplateDataError = error => ({
    type: actionTypes.FETCH_ERROR,
    payload: {
        message: error.message,
        status: error.status
    },
    error: true
});

export const fetchTemplateDataEpic = action$ =>
    action$.ofType(actionTypes.REQUEST).switchMap(action =>
        Observable.from(fetchTemplateDataRequest(action.payload))
            .map(data => {
                return fetchTemplateDataSuccess(data);
            })
            .catch(error =>
                Observable.concat(
                    Observable.of(fetchTemplateDataError(error)),
                    Observable.of(
                        setGlobalError(
                            error.errorMessage
                                ? error.errorMessage
                                : DEFAULT_ERROR_MSG
                        )
                    )
                )
            )
    );

export default [fetchTemplateDataEpic];
